import { produce } from "immer";
import {
  GET_GOVERNANCE,
  GET_GOVERNANCE_SUCCESS,
  GET_GOVERNANCE_FAILURE,
  SAVE_GOVERNANCE,
  SAVE_GOVERNANCE_SUCCESS,
  SAVE_GOVERNANCE_FAILURE,
  LOAD_GOVERNANCE_VERSION,
  LOAD_GOVERNANCE_VERSION_SUCCESS,
  LOAD_GOVERNANCE_VERSION_FAILURE,
  GET_RESIDENT_GOVERNANCE,
  GET_RESIDENT_GOVERNANCE_SUCCESS,
  GET_RESIDENT_GOVERNANCE_FAILURE,
  UPDATE_GOVERNANCE_STATUS,
  UPDATE_GOVERNANCE_STATUS_SUCCESS,
  UPDATE_GOVERNANCE_STATUS_FAILURE,
  COMPLETE_GOVERNANCE_ITEM,
  COMPLETE_GOVERNANCE_ITEM_SUCCESS,
  COMPLETE_GOVERNANCE_ITEM_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingGovernance: false,
  governance: {},
  isSubmittingGovernance: false,
  isLoadingGovernanceVersion: false,
  isFetchingResidentGovernance: false,
  residentGovernance: [],
  isUpdatingGovernanceStatus: false,
  isCompletingGovernanceItem: false,
};

const ResidentGovernanceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case GET_GOVERNANCE:
        draft.isFetchingGovernance = true;
        draft.governance = {};
        break;
      case GET_GOVERNANCE_SUCCESS:
        draft.isFetchingGovernance = false;
        draft.governance = action.payload;
        break;
      case GET_GOVERNANCE_FAILURE:
        draft.governance = {};
        draft.isFetchingGovernance = false;
        break;

      // Save
      case SAVE_GOVERNANCE:
        draft.isSubmittingGovernance = true;
        break;
      case SAVE_GOVERNANCE_SUCCESS:
        draft.isSubmittingGovernance = false;
        break;
      case SAVE_GOVERNANCE_FAILURE:
        draft.isSubmittingGovernance = false;
        break;

      // Load Version
      case LOAD_GOVERNANCE_VERSION:
        draft.isLoadingGovernanceVersion = true;
        break;
      case LOAD_GOVERNANCE_VERSION_SUCCESS:
        draft.isLoadingGovernanceVersion = false;
        break;
      case LOAD_GOVERNANCE_VERSION_FAILURE:
        draft.isLoadingGovernanceVersion = false;
        break;

      // Get Resident Governance
      case GET_RESIDENT_GOVERNANCE:
        draft.isFetchingResidentGovernance = true;
        draft.residentGovernance = [];
        break;
      case GET_RESIDENT_GOVERNANCE_SUCCESS:
        draft.isFetchingResidentGovernance = false;
        draft.residentGovernance = action.payload;
        break;
      case GET_RESIDENT_GOVERNANCE_FAILURE:
        draft.residentGovernance = [];
        draft.isFetchingResidentGovernance = false;
        break;

      // Update Governance Status
      case UPDATE_GOVERNANCE_STATUS:
        draft.isUpdatingGovernanceStatus = true;
        break;
      case UPDATE_GOVERNANCE_STATUS_SUCCESS:
        draft.isUpdatingGovernanceStatus = false;
        break;
      case UPDATE_GOVERNANCE_STATUS_FAILURE:
        draft.isUpdatingGovernanceStatus = false;
        break;

      // Complete Governance Item
      case COMPLETE_GOVERNANCE_ITEM:
        draft.isCompletingGovernanceItem = true;
        break;
      case COMPLETE_GOVERNANCE_ITEM_SUCCESS:
        draft.isCompletingGovernanceItem = false;
        break;
      case COMPLETE_GOVERNANCE_ITEM_FAILURE:
        draft.isCompletingGovernanceItem = false;
        break;

      default:
        return state;
    }
  });

export default ResidentGovernanceReducer;
